import { ChangeDetectorRef, ElementRef, SimpleChanges, Component, ComponentFactoryResolver, ViewChild, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { alert, confirm } from 'devextreme/ui/dialog';
import dxDataGrid from 'devextreme/ui/data_grid';
import * as moment from 'moment';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { NewNicaFormComponent } from '../../components/nica-form/new-nica-form.component';
import { Utenteservice } from '../../services/utente.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../services/api.service';
import { messagefromComponent } from '../../class/appinterface';

@Component({
   selector: 'app-statisticarifiuti-grafici',
   templateUrl: './statisticarifiuti-grafici.component.html',
   styleUrls: ['./statisticarifiuti-grafici.component.css'],
})
export class StatisticarifiutiGraficiComponent extends NicaMaster implements OnInit {
   @ViewChild('newNicaForm', { static: false }) newNicaForm: NewNicaFormComponent;
   @ViewChild('gridTest', { static: false }) gridTest: dxDataGrid;
   @ViewChild('inputElement', { static: false }) inputElement: ElementRef; // adele per mettere gli **** e disattivare input
   @Input() dataSourceType: any;
   @Output() selectedEvent: EventEmitter<any> = new EventEmitter<any>(); // Emit all'esterno
   @Output() selectedEventInitialized: EventEmitter<any> = new EventEmitter<any>(); // Emit all'esterno
   @Output() produttoreSelezionato = new EventEmitter<number>();
   @Input() fileDataInput: any;
   @Input() dataSelect: any;
   @Input() dataInput: any;
   @Input() formData: any;
   idSelect: number;
   shouldRestoreFieldStates: boolean = false;
   popupSelections: { [key: string]: { ragioneSociale: any[]; produttore_sede: any[] } } = {};
   @ViewChild('formSoggetto', { static: false }) formAnagrafica: NewNicaFormComponent;
   buttonCustom2 = [
      {
         location: 'after',
         widget: 'dxButton',
         locateInMenu: 'never',
         stylingMode: 'text',
         text: 'Reset',
         event: 'reset-form',
      },
      {
         location: 'after',
         widget: 'dxButton',
         locateInMenu: 'never',
         stylingMode: 'text',
         text: 'Genera',
         event: 'grafici-form',
      },
   ];
   // Aggiungi queste proprietà
   formVisible: boolean = true;
   chartData: any[] = [];
   selectionChangeEnabled: boolean = true;
   MovimentiElaborati: any;
   elementRef: any = {}; // adele oggetto
   formConfig: any;
   constructor(
      public utenteSerivce: Utenteservice,
      public userComponentService: ComponentService,
      public templateService: FormsTemplateService,
      public _overlaySideFormService: OverlaySideFormService,
      public _overlaySidePanelService: OverlaySideFormService,
      public formTemplateService: FormsTemplateService,
      public _componentFactoryResolver: ComponentFactoryResolver,
      public activatedroute: ActivatedRoute,
      public router: Router,
      public menuService: NicaMenuService,
      public rentriService: RentriService,
      public anagraficaService: AnagraficaService,
      public loader: NgxSpinnerService,
      public formservice: FormsTemplateService,
      public apiservice: Apiservice,
      private http: HttpClient,
      private cdRef: ChangeDetectorRef
   ) {
      super(
         userComponentService,
         templateService,
         _overlaySideFormService,
         _overlaySidePanelService,
         formTemplateService,
         _componentFactoryResolver,
         activatedroute,
         router,
         menuService,
         rentriService,
         anagraficaService
      );
   }

   messaggioFromComponent(message: messagefromComponent) {
      if (message.destComponent == 'StatisticarifiutiGraficiComponent' && message.traceMessage == 'endAnteprima') {
         this.loader.hide('xls');
      }
      console.log('ecco il messaggio ', message);
      //StatisticarifiutiGraficiComponent
   }
   ngOnInit(): void {
      //-------------------------
      this.userComponentService.castMessage.subscribe((message: messagefromComponent) => this.messaggioFromComponent(message));
      this.formConfig = this.formTemplateService.getTemplateService || {};
      //console.log("Template:", this.template);
      this.activatedroute.queryParams.subscribe((params) => {
         (this.currentTabId = params.currentTabId), (this.currentTabName = params.currentTabName);
      });
   }

   renderFormStitistiche(ev) {
      console.log('Logica per renderizzare il form ', ev);
      const that = this;
      setTimeout(() => {
         ev.component.elementRef['daData'].onInitialized.component.option('min', this.utenteSerivce.currentAnno + '-01-01');
         ev.component.elementRef['daData'].onInitialized.component.option('max', this.utenteSerivce.currentAnno + '-12-31');
         ev.component.elementRef['aData'].onInitialized.component.option('min', this.utenteSerivce.currentAnno + '-01-01', 'data');
         ev.component.elementRef['aData'].onInitialized.component.option('max', this.utenteSerivce.currentAnno + '-12-31', 'data');
      }, 1000);

      setTimeout(() => {
         that.selectionChangeEnabled = false;
         const listData: [] = ev.component.elementRef['causali'].onInitialized.component.option('items');
         if (ev.formData.causali)
            (ev.formData.causali as []).forEach((element) => {
               const index = listData.findIndex((x) => x['id'] === element);
               if (index > -1) ev.component.elementRef['causali'].onInitialized.component.selectItem(index);
            });

         const listDataPosizioni: [] = ev.component.elementRef['soloPosizioni'].onInitialized.component.option('items');
         if (ev.formData.idPosizioneRifiuto)
            (ev.formData.idPosizioneRifiuto as []).forEach((element) => {
               const index = listDataPosizioni.findIndex((x) => x['id'] === element);
               if (index > -1) ev.component.elementRef['soloPosizioni'].onInitialized.component.selectItem(index);
            });
         that.selectionChangeEnabled = true;

         // Tipo Statistica
         const listDataTipoStatistica: [] = ev.component.elementRef['tipoStatistica'].onInitialized.component.option('items');
         if (ev.formData.tipoStatistica)
            (ev.formData.tipoStatistica as []).forEach((element) => {
               const index = listDataTipoStatistica.findIndex((x) => x['id'] === element);
               if (index > -1) ev.component.elementRef['tipoStatistica'].onInitialized.component.selectItem(index);
            });
      }, 500);

      //e.component.option("min", new Date(now.getFullYear(), now.getMonth(), now.getDate() + 10));
   }

   formItemsEvent(ev) {
      if (ev.name == 'onValueChanged') {
         if (ev.campo.dataField === 'destinatario_Descrizione_Sede') {
            this.newNicaForm.dataSet['descrizione_MagazzinoDestinatario_Descrizione'] = [];
            this.newNicaForm.dataSet['autorizzazioneDestinatario'] = null;
            this.newNicaForm.dataSet['idMagazzinoDestinatario'] = null;
            this.newNicaForm.dataSet['idCantiereFuoriUlDestinatario'] = null;
         }
         if (ev.campo.dataField === 'isUrbano' || ev.campo.dataField === 'isUrbanoNo') {
            if (this.newNicaForm.dataSet['isUrbano']) {
               this.newNicaForm.itemOption('filtroGruppo.isUrbanoNo', 'disabled', this.newNicaForm.dataSet['isUrbano']);
            } else if (this.newNicaForm.dataSet['isUrbanoNo']) {
               this.newNicaForm.itemOption('filtroGruppo.isUrbano', 'disabled', this.newNicaForm.dataSet['isUrbanoNo']);
            } else {
               this.newNicaForm.itemOption('filtroGruppo.isUrbano', 'disabled', false);
               this.newNicaForm.itemOption('filtroGruppo.isUrbanoNo', 'disabled', false);
            }
         }

         if (ev.campo.dataField === 'destinatario_Descrizione_Soggetto') {
            this.newNicaForm.itemOption('sceltaProduttore.descrizione_MagazzinoDestinatario_Descrizione', 'disabled', !(ev.formData.destinatario_Id_Soggetto > 0));
            this.newNicaForm.itemOption('sceltaProduttore.destinatario_Descrizione_Sede', 'disabled', !(ev.formData.destinatario_Id_Soggetto > 0));
            this.newNicaForm.itemOption('sceltaProduttore.autorizzazioneDestinatario', 'disabled', !(ev.formData.destinatario_Id_Soggetto > 0));
            this.newNicaForm.dataSet['idCantiereFuoriUl'] = null;

            this.newNicaForm.dataSet['idAutorizzazioneDestinatario'] = null;
            this.newNicaForm.dataSet['magazzinoDestinatario_Descrizione'] = null;
            this.newNicaForm.dataSet['autorizzazioneDestinatario'] = null;

            this.newNicaForm.dataSet['idMagazzinoDestinatario'] = null;
            this.newNicaForm.dataSet['idCantiereFuoriUlDestinatario'] = null;
         }

         if (ev.campo.dataField === 'trasportatore_Descrizione_Soggetto') {
            this.newNicaForm.itemOption('sceltaProduttore.autorizzazioneTrasporsportatore', 'disabled', !(ev.formData.trasportatore_Id_Soggetto > 0));
            this.newNicaForm.itemOption('sceltaProduttore.automezzo', 'disabled', !(ev.formData.trasportatore_Id_Soggetto > 0));
            this.newNicaForm.itemOption('sceltaProduttore.rimorchio', 'disabled', !(ev.formData.trasportatore_Id_Soggetto > 0));
            this.newNicaForm.itemOption('sceltaProduttore.autista', 'disabled', !(ev.formData.trasportatore_Id_Soggetto > 0));
            this.newNicaForm.dataSet['automezzo'] = null;
            this.newNicaForm.dataSet['autorizzazioneTrasporsportatore'] = null;
            this.newNicaForm.dataSet['rimorchio'] = null;
            this.newNicaForm.dataSet['autista'] = null;
         }
         if (ev.campo.dataField === 'produttore_Descrizione_Sede') {
            this.newNicaForm.dataSet['autorizzazione'] = null;
            this.newNicaForm.dataSet['idMagazzinoProduttore'] = null;
            this.newNicaForm.dataSet['descrizione_IdMagazzinoProduttore'] = null;
            this.newNicaForm.dataSet['cantiereProduttore_Descrizione'] = null;
         }
         if (ev.campo.dataField === 'produttore_Descrizione_Soggetto') {
            this.newNicaForm.itemOption('sceltaProduttore.produttore_Descrizione_Sede', 'disabled', !(ev.formData.produttore_Id_Soggetto > 0));
            this.newNicaForm.itemOption('sceltaProduttore.produttore_Descrizione_Sede', 'disabled', !(ev.formData.produttore_Id_Soggetto > 0));
            this.newNicaForm.itemOption('sceltaProduttore.autorizzazione', 'disabled', !(ev.formData.produttore_Id_Soggetto > 0));
            this.newNicaForm.itemOption('sceltaProduttore.descrizione_IdMagazzinoProduttore', 'disabled', !(ev.formData.produttore_Id_Soggetto > 0));
            this.newNicaForm.itemOption('sceltaProduttore.cantiereProduttore_Descrizione', 'disabled', !(ev.formData.produttore_Id_Soggetto > 0));
            this.newNicaForm.dataSet['autorizzazione'] = null;
            this.newNicaForm.dataSet['idMagazzinoProduttore'] = null;
            this.newNicaForm.dataSet['descrizione_IdMagazzinoProduttore'] = [];
            this.newNicaForm.dataSet['cantiereProduttore_Descrizione'] = [];
         }
      }
      if (ev.name == 'beforeMitter') {
         if (ev.campo.dataField === 'produttore_Descrizione_Sede') {
            if (ev.formData.produttore_Id_Soggetto === 0 || ev.formData.produttore_Id_Soggetto === undefined) {
               alert('Devi prima selezionare la sede ', 'Attenzione');
               ev.cancel = true;
               return;
            }
         }
      }
      //console.log("In Form Event ------------- ",ev)
   }

   formatString(stringa, lunghezza) {
      if (stringa.length > lunghezza) {
         // Tronca la stringa se è più lunga della lunghezza specificata
         return stringa.slice(0, lunghezza);
      } else {
         // Aggiunge spazi alla fine della stringa per raggiungere la lunghezza specificata
         return stringa.padEnd(lunghezza, ' ');
      }
   }

   findAllValuesByKey(jsonObject: any, key: string): any[] {
      let results: any[] = [];

      if (jsonObject.hasOwnProperty(key)) {
         results.push(jsonObject[key]);
      }

      for (let prop in jsonObject) {
         if (jsonObject.hasOwnProperty(prop)) {
            const value = jsonObject[prop];

            // Se l'elemento è un oggetto, richiamare la funzione ricorsivamente
            if (typeof value === 'object' && value !== null) {
               results = results.concat(this.findAllValuesByKey(value, key));
            }
         }
      }

      return results;
   }

   buildQueryAndFetchData(filterString) {
      const nowIniziale = moment(this.newNicaForm.dataSet.daData);
      const nowFinale = moment(this.newNicaForm.dataSet.aData);
      if (nowFinale.isBefore(nowIniziale)) {
         alert('Intervallo di date errato', 'Errore');
         return;
      }
      if (nowIniziale.year() != nowFinale.year()) {
         alert("L'intervallo di date non può comprendere anni diversi", 'Errore');
         return;
      }
      if (filterString > '') {
         filterString = filterString.replace('daData', 'dataRegistrazione');
         filterString = filterString.replace('aData', 'dataRegistrazione');
         filterString = filterString.replaceAll('isUrbanoNo eq true', 'isUrbano eq false');
         filterString = filterString.replaceAll("!'", '');
         filterString = filterString.replaceAll('descrizione_IdStatoFisico', 'statoFisico_Descrizione');
         let orderby = '';
         if (this.newNicaForm.dataSet['tipoStatistica'] == 1) {
            orderby = 'eer';
         } else if (this.newNicaForm.dataSet['tipoStatistica'] == 2) {
            orderby = 'eer,idStatoFisico,isUrbano';
         } else if (this.newNicaForm.dataSet['tipoStatistica'] == 3) {
            orderby = 'eer,riferimentoEER';
         } else if (this.newNicaForm.dataSet['tipoStatistica'] == 4) {
            orderby = 'dataRegistrazione';
         } else if (this.newNicaForm.dataSet['tipoStatistica'] == 5) {
            orderby = 'idCliente';
         } else if (this.newNicaForm.dataSet['tipoStatistica'] == 6) {
            orderby = 'idProduttore';
         } else if (this.newNicaForm.dataSet['tipoStatistica'] == 7) {
            orderby = 'idTrasportatore';
         } else if (this.newNicaForm.dataSet['tipoStatistica'] == 8) {
            orderby = 'idDestinatario';
         }
         // Controllo se cisono filtri estesi
         let results: any[] = [];
         results = this.findAllValuesByKey(this.newNicaForm.dataSet, 'oDataFilter');
         for (let elem in results) {
            if (results[elem] > '') filterString += ' and ' + results[elem];
         }
         return orderby !== ''
            ? `MovimentoRifiuti/GetAllExtend?$filter=${encodeURIComponent(filterString)}&orderby=${orderby}`
            : `MovimentoRifiuti/GetAllExtend?$filter=${encodeURIComponent(filterString)}`;
      } else {
         alert('Errore nel generazione dei dati, ti preghiamo di riprovare', 'Errore');
         return;
      }
   }

   // Metodo per mostrare la form
   showForm() {
      $('#chartContainer').addClass('d-none');
      this.formVisible = true;
   }

   formButtonsEvent(selectedValue: any) {
      console.log(selectedValue);
      if (selectedValue.name === 'reset-form') {
         confirm('Sei sicuro di voler resettare il form?', 'Reset Form?').then((x) => {
            if (!x) {
               return;
            } else {
               // Resetta tutti i dati del form
               this.newNicaForm.dataSet = {}; // Pulisci tutti i dati del form
               this.newNicaForm.dataSet['isUrbano'] = false;
               this.newNicaForm.dataSet['isUrbanoNo'] = false;
               this.popupSelections = {}; // Resetta le selezioni dei popup
               this.formVisible = true; // Rendi visibile la form
               // Resetta i campi 'select'
               if (this.newNicaForm.formData) {
                  this.newNicaForm.formData['causali'] = []; // Resetta il campo 'causali' a un array vuoto
                  // Resetta anche altri campi se necessario
                  this.newNicaForm.formData['soloPosizioni'] = []; // Resetta il campo 'soloPosizioni'
               }
               // Resetta i campi select chiamando la funzione di reset delle select
               this.resetSelectFields();
               // Aggiorna la vista e forza la change detection
               this.cdRef.detectChanges();
               return alert('Form resettata con successo!', 'Form Resettato');
            }
         });
      } else if (selectedValue.name === 'grafici-form') {
         if (this.newNicaForm.dataSet['daData'] == null) {
            this.newNicaForm.dataSet['daData'] = this.utenteSerivce.currentAnno + '-01-01';
         }
         if (this.newNicaForm.dataSet['aData'] == null) {
            this.newNicaForm.dataSet['aData'] = this.utenteSerivce.currentAnno + '-12-31';
         }
         ['daData', 'aData'].forEach((key) => {
            if (this.newNicaForm.dataSet[key]) {
               this.newNicaForm.dataSet[key] = this.newNicaForm.dataSet[key].replace(/\//g, '-');
            }
         });
         let TipoStatistica = this.newNicaForm.dataSet['tipoStatistica'] ? this.newNicaForm.dataSet['tipoStatistica'][0] : 0;
         if (!TipoStatistica) {
            alert('Selezionata il tipo statistica', 'Attenzione');
            return;
         } else if (TipoStatistica === 5) {
            alert("Tipo di statistica non al momento disponibile, seleziona un'altra statistica", 'Attenzione');
            return;
         }
         this.newNicaForm.generaOdata().then((x) => {
            const url = this.buildQueryAndFetchData(x);
            console.log(x);
            if (!url) {
               return alert("Errore nella generazione dell'url, riprovare", 'Errore');
            }
            console.log('%cUrl Odata: ', 'background-color:yellow;color:black', url);
            return this.popUpGrafici(url);
         });
      }
   }

   popUpGrafici(url: string, dettagliGrafico?) {
      console.log('Valore di tipoStatistica:', this.newNicaForm.dataSet['tipoStatistica']);
      console.log('Valore :', dettagliGrafico);
      let that = this;
      const guida = Math.random().toString().replace('0.', '') + 'statisticheGrafici';
      let dataToSend = {
         urlOdata: url,
         statistica: this.newNicaForm.dataSet['tipoStatistica'][0],
         dettagli: dettagliGrafico,
      };
      this.userComponentService.setNewPopUp(guida, 'WidgetGraficiComponent', null, '1600', null, dataToSend, false, true, 'Grafico Statistiche Rifiuti', 'top');
      // Imposta le date nella newNicaForm (form che hai già definito)
      setTimeout(() => {
         // Se esistono date da/a nel newNicaForm, imposta i valori min/max nelle date
         if (that.newNicaForm && that.newNicaForm.dataSet) {
            const daData = that.newNicaForm.dataSet.daData || `${this.utenteSerivce.currentAnno}-01-01`;
            const aData = that.newNicaForm.dataSet.aData || `${this.utenteSerivce.currentAnno}-12-31`;

            // Imposta i limiti nelle date della form
            if (that.newNicaForm.elementRef) {
               const daDataElement = that.newNicaForm.elementRef['daData'];
               const aDataElement = that.newNicaForm.elementRef['aData'];

               // Se i campi esistono, imposta le opzioni min/max
               if (daDataElement) {
                  daDataElement.onInitialized.component.option('min', `${this.utenteSerivce.currentAnno}-01-01`);
                  daDataElement.onInitialized.component.option('max', `${this.utenteSerivce.currentAnno}-12-31`);
                  daDataElement.onInitialized.component.option('value', daData);
               }

               if (aDataElement) {
                  aDataElement.onInitialized.component.option('min', `${this.utenteSerivce.currentAnno}-01-01`);
                  aDataElement.onInitialized.component.option('max', `${this.utenteSerivce.currentAnno}-12-31`);
                  aDataElement.onInitialized.component.option('value', aData);
               }
            }
         }
      }, 1000); // Attendi 1 secondo per permettere il rendering della form
      return;
   }

   selezionaLeUnitaLocali(selectedIds: number[], fieldName: string, formComponent: any) {
      if (selectedIds == null) return;
      if (selectedIds && selectedIds.length == 0) return;

      const listData: [] = formComponent.elementRef[fieldName].onInitialized.component.option('items');
      for (const sede of selectedIds) {
         const index = listData.findIndex((x) => x['id'] === sede);
         if (index > -1) {
            formComponent.elementRef[fieldName].onInitialized.component.selectItem(index);
         }
      }
   }
   selectItemsComponentOnInit(selectedIds: number[], fieldName: string, formComponent: any) {
      if (selectedIds == null) return;
      if (selectedIds && selectedIds.length == 0) return;
      //this.selectionChangeEnabled=false;
      const listData: [] = formComponent.elementRef[fieldName].onInitialized.component.option('items');
      const indices = selectedIds.reduce((acc, refId) => {
         const itemIndices = listData.reduce((result, item, index) => {
            if (item['id'] === refId) {
               result.push(index);
            }
            return result;
         }, []);
         return acc.concat(itemIndices);
      }, []);
      for (const id of indices) {
         formComponent.elementRef[fieldName].onInitialized.component.selectItem(id);
      }
      setTimeout(() => {
         this.selectionChangeEnabled = true;
      }, 100);
   }
   selectItemsInComponent(selectedIds: number[], fieldNameSedi: string, formComponent: any, operation: string) {
      //selectedIds=elenco soggetti selezionati
      //fieldNameSoggetti
      if (!this.selectionChangeEnabled) return;
      this.selectionChangeEnabled = false;
      let component;
      component = formComponent.elementRef[fieldNameSedi].onInitialized.component;
      const listaSedi: any[] = component.option('items');
      const indices = selectedIds.reduce((acc, refId) => {
         const itemIndices = listaSedi.reduce((result, item, index) => {
            if (item.idSoggetto === refId) {
               result.push(index);
            }
            return result;
         }, []);
         return acc.concat(itemIndices);
      }, []);
      //unselectAll
      for (const idSede of indices) {
         if (operation == 'add') component.selectItem(idSede);
         else component.unselectItem(idSede);
      }
      this.refreshComponent(fieldNameSedi, formComponent);
      this.selectionChangeEnabled = true;
   }

   refreshComponent(fieldName: string, formComponent: any) {
      const component = formComponent.elementRef[fieldName].onInitialized.component;
      component._refresh();
   }

   // Funzione per resettare i campi di selezione
   resetSelectFields() {
      // Resetta le select utilizzando le ViewChild per accedere ai componenti
      if (this.newNicaForm && this.newNicaForm.elementRef) {
         if (this.newNicaForm.elementRef['causali'] && this.newNicaForm.elementRef['causali'].onInitialized) {
            const causaliComponent = this.newNicaForm.elementRef['causali'].onInitialized.component;
            if (causaliComponent) {
               causaliComponent.unselectAll(); // Deseleziona tutte le opzioni
               causaliComponent.option('value', []); // Resetta il valore a un array vuoto
            }
         }

         // Resetta altre select se necessario
         if (this.newNicaForm.elementRef['soloPosizioni'] && this.newNicaForm.elementRef['soloPosizioni'].onInitialized) {
            const soloPosizioniComponent = this.newNicaForm.elementRef['soloPosizioni'].onInitialized.component;
            if (soloPosizioniComponent) {
               soloPosizioniComponent.unselectAll();
               soloPosizioniComponent.option('value', []);
            }
         }
         if (this.newNicaForm.elementRef['tipoStatistica'] && this.newNicaForm.elementRef['tipoStatistica'].onInitialized) {
            const soloPosizioniComponent = this.newNicaForm.elementRef['tipoStatistica'].onInitialized.component;
            if (soloPosizioniComponent) {
               soloPosizioniComponent.unselectAll();
               soloPosizioniComponent.option('value', []);
            }
         }
      }
   }
}
